import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VPagination,{attrs:{"outlined":"","total-visible":"7","length":_vm.getLogs.last_page},on:{"input":function($event){return _vm.setPage($event)}},model:{value:(_vm.getLogFiltros.current_page),callback:function ($$v) {_vm.$set(_vm.getLogFiltros, "current_page", $$v)},expression:"getLogFiltros.current_page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }